import DateTimeUtil from "./dateTimeUtil";
import * as d3 from "d3";
import { PQ4castDataType } from "../models/metMap/pQ4castDataType";
import ForecastTypeLogic from "../logic/forecastTypeLogic";
import ScaleLogic from "../logic/scaleLogic";
class FormatUtil {
    static formatTimeAdaptive(time, showSeconds = false) {
        const now = new Date();
        let result = "";
        const dayDiff = time < now ?
            DateTimeUtil.allDaysBetween(time, now).length :
            -(DateTimeUtil.allDaysBetween(now, time).length);
        const yearIfNotSame = time.getFullYear() === now.getFullYear() ? "" : " " + time.getFullYear();
        const today = dayDiff === 1 && time.getDay() === now.getDay();
        const yesterday = dayDiff === 2 && time.getDay() === DateTimeUtil.addHours(now, -24).getDay();
        const tomorrow = dayDiff === -1 && time.getDay() === DateTimeUtil.addHours(now, 24).getDay();
        const clockPattern = showSeconds ?
            "%H:%M:%S" : "%H:%M";
        const clock = d3.timeFormat(clockPattern)(time);
        if (today)
            result = "Today " + clock;
        else if (yesterday)
            result = "Yesterday " + clock;
        else if (tomorrow)
            result = "Tomorrow " + clock;
        else
            result = d3.timeFormat("%-d %b")(time) + yearIfNotSame + " " + clock;
        return result;
    }
    static formatTime(time, showDate = true, showSeconds = true) {
        const clockPattern = showSeconds ?
            "%H:%M:%S" : "%H:%M";
        if (showDate)
            return d3.timeFormat(`%Y-%m-%d ${clockPattern}`)(time);
        return d3.timeFormat(clockPattern)(time);
    }
    static formatDate(time) {
        return d3.timeFormat("%Y-%m-%d")(time);
    }
    static fValueAutoScale(value, dataType) {
        const scale = ForecastTypeLogic.isScalable(dataType) ? ScaleLogic.preferredScale(value) : 1;
        return FormatUtil.fValue(value, dataType, scale);
    }
    static fValue(value, dataType, scale = 1) {
        return isNaN(value) ? "-" :
            dataType === PQ4castDataType.Temperature ? `${value.toFixed(1)} ${ForecastTypeLogic.getUnit(dataType)}` :
                `${FormatUtil.g3(ScaleLogic.valueScaled(value, scale))} ${ScaleLogic.unitScaled(ForecastTypeLogic.getUnit(dataType), scale)}`;
    }
}
FormatUtil.g3 = function (n) { return FormatUtil.g(n, 3); };
FormatUtil.g = function (n, decimals) { return isNaN(n) ? "-" : n.toPrecision(decimals); };
FormatUtil.tShort = function (time) { return time.toDateString(); };
export default FormatUtil;
